var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.franchiseId)?_c('onboardClinic',{attrs:{"backRoute":"SuperAdminClinic","doctorClinicId":_vm.franchiseId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }